jQuery(function($) {

	const mqIsLg = window.matchMedia('(min-width: 992px)'); //where to switch from brochure mode to mobile scroll mode
	const $slides = $('.uppslag-wrapper');
	const $progressionBar = $('.inner-progression');
	//make the linked slide visible, or just the first as default
	var strSlideNum = window.location.hash;
	if(strSlideNum.length > 0) {
		$(strSlideNum).addClass('active');
	} else {
		$slides.first().addClass('active');
	}
	var currentSlide = $('.uppslag-wrapper.active');
	const arrPageNums = []; //maps the slides to the displayed page numbers
	const $pageNum = $('.js-pagenum'); //where to display the page numbers

	//force aspect ratio for uppslag regardless of device
	function fixedAspectRatioInLgMode() {
		if (mqIsLg.matches) {
			setAspectRatio(currentSlide);
		}
	};
	$(window).on('resize', fixedAspectRatioInLgMode);

	function setAspectRatio($slide) {
		const width = $slide.width();
		if($slide.hasClass('max-w-brochure-single')) {
			$slide.css('height', width);
		} else {
			$slide.css('height', width / 2);
		}
	}


	syncProgressionbar(currentSlide.index() + 1);
	syncNavButtons();
	fixedAspectRatioInLgMode();


	// Brochure navigation
	function stepNext(e) {
		// console.log('stepNext');
		var href = $(this).attr('href');
		if(href.length === 0) {e.preventDefault(); return;}
		var next = $(href);
		if(next.length === 0) {return;} //no slide to navigate to
		window.removeEventListener('hashchange', onHashChange);
		startAnimNext(currentSlide, next);
	}
	function stepPrev(e) {
		// console.log('stepPrev');
		var href = $(this).attr('href');
		if(href.length === 0) {e.preventDefault(); return;}
		var prev = $(href);
		if(prev.length === 0) {return;} //no slide to navigate to
		window.removeEventListener('hashchange', onHashChange);
		startAnimPrev(currentSlide, prev);
	}

	//goes from one slide to the other using the "step next" animation
	function startAnimNext(current, next) {
		$(".brochure-pagi").off('click', '.brochure-next', stepNext); //prevent stepping while animation already begun
		$(".brochure-pagi").off('click', '.brochure-prev', stepPrev);//prevent stepping while animation already begun
		current.on('animationend', animCompleteOut);
		current.addClass('nextOut');
		next.on('animationend', animCompleteCurrent);
		next.addClass('next');
		if (mqIsLg.matches) {
			setAspectRatio(next);
		}
		syncProgressionbar(next.index() + 1);
		$pageNum.text(arrPageNums[next.index()]);
	}
	//goes from one slide to the other using the "step previous" animation
	function startAnimPrev(current, prev) {
		$(".brochure-pagi").off('click', '.brochure-prev', stepPrev);//prevent stepping while animation already begun
		$(".brochure-pagi").off('click', '.brochure-next', stepNext); //prevent stepping while animation already begun
		current.on('animationend', animCompleteOut);
		current.addClass('prevOut');
		prev.on('animationend', animCompleteCurrent);
		prev.addClass('prev');
		if (mqIsLg.matches) {
			setAspectRatio(prev);
		}
		syncProgressionbar(prev.index() + 1);
		$pageNum.text(arrPageNums[prev.index()]);
	}

	//cleans things up once the new slide has animated in
	function animCompleteCurrent() {
		// console.log('animCompleteCurrent');
		var $this = $(this);
		$this.addClass('active').removeClass('next prev').off('animationend', animCompleteCurrent);
		currentSlide = $this;
		syncNavButtons();
	}
	//cleans things up once the old slide has animated out
	function animCompleteOut() {
		// console.log('animCompleteOut');
		$(this).removeClass('nextOut prevOut active').off('animationend', animCompleteOut);
	}

	function syncProgressionbar(order) {
		// console.log('syncProgressionbar');
		$progressionBar.css('width', (order/$slides.length * 100) + '%' );
	}
	function syncNavButtons() {
		// console.log('syncNavButtons');
		var next = currentSlide.next('.uppslag-wrapper');
		if(next.length > 0) {
			$('.brochure-next').attr('href', '#' + next.attr('id')).removeClass('inactive');
		} else {
			$('.brochure-next').attr('href', '').addClass('inactive');
		}
		var prev = currentSlide.prev('.uppslag-wrapper');
		if(prev.length > 0) {
			$('.brochure-prev').attr('href', '#' + prev.attr('id')).removeClass('inactive');
		} else {
			$('.brochure-prev').attr('href', '').addClass('inactive');
		}
		$(".brochure-pagi").on('click', '.brochure-next', stepNext);
		$(".brochure-pagi").on('click', '.brochure-prev', stepPrev);
		window.addEventListener('hashchange', onHashChange);
	}

	//An incredibly ugly goddamn hack just to get a "console" log in iOS. GODDAMN I hate Apple
	// const $ipadConsole = $('#ipadConsole');
	// function ipadLog(strMessage) {
	// 	$ipadConsole.html($ipadConsole.html() + '<br/>' + strMessage);
	// }

	mqIsLg.addListener(switchFunctionalityInMobileOrDesktop);
	function switchFunctionalityInMobileOrDesktop() {
		if(mqIsLg.matches) {
			if(window.location.hash) { //otherwise we have nowhere to switch to (most likely on page init in desktop)
				window.removeEventListener('scroll', markCurrentSlideOnScroll, {passive:true});
				currentSlide = $(window.location.hash);
				$slides.removeClass('active');
				currentSlide.addClass('active');
				syncNavButtons();
				$pageNum.text(arrPageNums[currentSlide.index()]);
			}
		} else {
			window.removeEventListener('hashchange', onHashChange);
			window.requestAnimationFrame(function() { //basically, wait for repaint in the browser before scrolling
				currentSlide[0].scrollIntoView();
				window.addEventListener('scroll', markCurrentSlideOnScroll, {passive:true});
			});
			$slides.css('height', 'auto');
		}
	}

	function markCurrentSlideOnScroll() {
		//TODO: this has an edge case where it won't work if first slide is tiny. Check before launch if we have one of those
		var last;
		var halfHeight = document.documentElement.clientHeight / 2;
		$slides.each(function() {
			var rect = this.getBoundingClientRect();
			if(rect.top > halfHeight) {
				return false;
			}
			last = this;
		});
		const newHash = '#' + last.getAttribute('id');
		if(newHash !== window.location.hash) {
			history.replaceState('', '', newHash);
			currentSlide = $(newHash);
			syncProgressionbar(currentSlide.index() + 1);
			$pageNum.text(arrPageNums[currentSlide.index()]);

		}

	}
	switchFunctionalityInMobileOrDesktop();

	(function() { //scope
		//this snippet builds the page-number-to-slide-map
		var lastNum = 1;
		var dir = $('body').attr('dir');
		$slides.each(function() {
			if(this.className.indexOf('max-w-brochure-single') > -1) {
				arrPageNums.push(lastNum.toString());
				lastNum += 1;
			} else {
				if(dir == 'ltr') { arrPageNums.push(lastNum + '-' + (lastNum + 1));}
				else {arrPageNums.push((lastNum + 1) + '-' + lastNum);}
				lastNum += 2;
			}
		});
		$pageNum.text(arrPageNums[currentSlide.index()]);
	})();

	//this is basically all that's needed for the table of contents and slide navigation. When the hash changes (to a slide that exists), just switch to that slide
	//note though, since we have separate handling of this in the nav buttons (and no handling at all of it in mobile), it's temporarily turned off there
	window.addEventListener('hashchange', onHashChange);
	function onHashChange() {
		var slide = $(location.hash);
		if(slide.length > 0 && slide.hasClass('uppslag-wrapper') && slide.attr('id') !== currentSlide.attr('id')) {
			if(currentSlide.index() > slide.index()) {
				startAnimPrev(currentSlide, slide);
			} else {
				startAnimNext(currentSlide, slide);
			}
		}
	}







	// jQuery('.brochure-nav').on('click', function () {
	// 	jQuery('.brochure-nav').toggleClass('brochure-nav-active');
	// });

	// jQuery('.brochure-lang').on('click', function () {
	// 	jQuery('.brochure-lang').toggleClass('brochure-lang-active');
	// });
	let is_printing = false;
	$(document).bind("keyup keydown", function(e){
    if(e.ctrlKey && e.keyCode == 80){
			e.preventDefault();
			if(!is_printing) {
				printBrochure();
			}
    }
	});
	$('.js-print-pdf').on('click', function (e) {
		e.preventDefault();
		if(!is_printing) {
			printBrochure();
		}
	});
	function printBrochure() {
		is_printing = true;
		const active_height = $('.uppslag-wrapper.active').css('height');
		$('body').append('<div class="print-area"></div>');
		const printHtml = $('.print-area').html($('.outer-wrapper').html());
		$('nav').addClass('hide-print');
		$('.outer-wrapper').addClass('hide-print');
		$('.progression').addClass('hide-print');
		$(printHtml).find('img').remove();
		$(printHtml).find('hr').remove();
		$(printHtml).find('.brochure-pagi').remove();
		$(printHtml).find('div').removeAttr('style');
		window.print();
		window.onfocus=function(){
			$('nav').removeClass('hide-print');
			$('.outer-wrapper').removeClass('hide-print');
			$('.progression').removeClass('hide-print');
			$('.print-area').remove();
			$('.uppslag-wrapper.active').css('height',active_height);
			is_printing = false;
		}
	}

});
